import React, { Component } from 'react';
import _ from 'lodash';

import TrafficSignsTable from '../components/TrafficSignsTable';

import TrafficSignsModel from '../components/TrafficSignsModel';
import ParkinglocationSelect from '../components/ParkinglocationSelect';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class TrafficSignsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    searchedTextValue: "",
    searchedDescriptionValue: "",
    dataAll: [],
    data: [],
    parkinglocationId: null
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.parkinglocationId);

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload && this.state.parkinglocationId) {
        this.loadData(this.state.parkinglocationId);
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  filterData(dataAll, searchedTextValue, searchedDescriptionValue) {
    let data = dataAll;
    if (searchedTextValue) {
      data = _.filter(data, (d) => { return d['serialNumber'].startsWith(searchedTextValue); });
    }
    if (searchedDescriptionValue) {
      data = _.filter(data, (d) => {
        return typeof (d['description']) === 'string' && d['description'].toLowerCase().includes(searchedDescriptionValue.toLowerCase());
      });
    }
    return data;
  }

  loadData(parkinglocationId) {
    this.setState({
      dataLoading: true
    });
    TrafficSignsModel.getAll(parkinglocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: this.filterData(data, this.state.searchedTextValue, this.state.searchedDescriptionValue)
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    this.setState({
      data: this.filterData(this.state.dataAll, searchText, this.state.searchedDescriptionValue)
    });
  }
  onSearchDescription(searchText) {
    this.setState({
      data: this.filterData(this.state.dataAll, this.state.searchedTextValue, searchText)
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Informační tabule - Seznam tabulí</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <ParkinglocationSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", searchedDescriptionValue: "", parkinglocationId: value });
                  }}
                  style={{ width: 300 }} />
                {' '}
                <Input.Search
                  placeholder="Najít seriové číslo"
                  value={this.state.searchedTextValue}
                  onSearch={this.onSearch.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 200 }} />
                <Input.Search
                  placeholder="Najít popis"
                  value={this.state.searchedDescriptionValue}
                  onSearch={this.onSearchDescription.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedDescriptionValue: e.target.value
                    })
                  }}
                  style={{ width: 200 }} />
              </Col>
              <Col span={8} offset={0} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.parkinglocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {/* {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ parkinglocationFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null} */}
              </Col>
            </Row>
          </div>
          <TrafficSignsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRowRemoved={() => {
              this.loadData(this.state.parkinglocationId);
            }}
            onAnyFormSuccess={() => {
              this.loadData(this.state.parkinglocationId);
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TrafficSignsScreen;



// WEBPACK FOOTER //
// ./src/screens/TrafficSignsScreen.js